<template lang="pug">
  div
    .parallax
      v-row(align="center" style="height:100%")
        v-col(cols="12" align="center")
          .display-2.justify-center Worship Arts & Music
    v-container()
      v-row(justify="center")
        v-col(cols="12" md="4" align="center")
          .title.mb-1 Art & Music Images
          div(style="max-width:500px")            
            v-carousel(cycle hide-delimiter-background delimiter-icon="mdi-circle-medium" 'show-arrows-on-hover' width="450" height="450"  )
              v-carousel-item(v-for="(photo,i) in photos" :key="i" :src="photo", 'reverse-transition'="fade-transition" transition="fade-transition")
        v-col(cols="12" md="8")
          p.headline About Us
          p.body-1 The Ministry of Worship Arts and Music is responsible for creating a lively, diverse, and engaging encounter of God's presence in the worshiping community.
          p.headline Our Vision 
          p.body-1 Our foundational worship style has been described as "Metho-Bapti-Costal" because we celebrate our relationship with God and each other in "full embodiment praise." Additionally, though, we seek to learn and share a variety of worship and musical styles in order to honor the diversity of our congregation and celebrate God's praise through many voices and expressions.
          p.title Current Ministry
          p.body-1 Our Worship & Liturgy Planning Team meets monthly to develop our Sunday and other worship experiences which include music, prayer, spoken word, dance, spontaneous praise and the proclamation of the living word.
        v-col(cols="12") 
          p.body-1 Our music department, led by our Minister of Music, musicians, and Music Leadership Team supports several musical entities including:
          ul
            li Praise Ensemble
            li Sanctuary Choir
            li Children, Youth & Young Adult Choirs
            li Men's Choir
            li Transcendence Gospel Choir
            li Spoken Word Ensemble
            li Hymns, Anthems & Spiritual Choir
            li and other occasional choirs (for special celebrations or holidays)
          p.title Contact
          .body-1 For more information contact:
          .body-1
            a(:href="mailTo" target="_blank" )
              span.theEmail.pb-1 Pastor Ann Jefferson
            | , Pastor of Worship & Liturgy 
          
</template>

<script>
export default {
  data() {
    return {
      photos: [
        {
          src: require('../../assets/img/art_music/3314375.jpg')
        },
        {
          src: require('../../assets/img/art_music/3598130.jpg')
        },
        {
          src: require('../../assets/img/art_music/3650436.jpg')
        },
        {
          src: require('../../assets/img/art_music/5502875.jpg')
        },
        {
          src: require('../../assets/img/art_music/6479035.jpg')
        },
        {
          src: require('../../assets/img/art_music/7764887.jpg')
        },
        {
          src: require('../../assets/img/art_music/904656.jpg')
        }
      ]
    };
  }
};
</script>

<style lang="stylus" scoped>
.parallax
  background-image url('../../assets/img/1974337_orig.png')
  height 300px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size 100%
  color white

.body-1a
  text-decoration none

.theEmail
  border-bottom 1px solid #000000
  color var(--v-primary-darken2)

.theEmail:hover
  border-bottom 1px solid rgba(0, 0, 0, 0)
  color var(--v-info-darken2)
</style>
